// Import the real cities data
import citiesData from "./cities_10k.json";

// Use the real cities data
export const cities = citiesData;

// Sample data structure (keeping for reference)
export const sampleCities = [
  {
    name: "Tokyo",
    ascii_name: "Tokyo",
    latitude: 35.6762,
    longitude: 139.6503,
    country_code: "JP",
    admin1_code: "13",
    population: 13929286,
    timezone: "Asia/Tokyo",
    geonameid: 1850147,
  },
  {
    name: "New York",
    ascii_name: "New York",
    latitude: 40.7128,
    longitude: -74.006,
    country_code: "US",
    admin1_code: "NY",
    population: 8336817,
    timezone: "America/New_York",
    geonameid: 5128581,
  },
  {
    name: "London",
    ascii_name: "London",
    latitude: 51.5074,
    longitude: -0.1278,
    country_code: "GB",
    admin1_code: "ENG",
    population: 8982000,
    timezone: "Europe/London",
    geonameid: 2643743,
  },
  {
    name: "Seoul",
    ascii_name: "Seoul",
    latitude: 37.5665,
    longitude: 126.978,
    country_code: "KR",
    admin1_code: "11",
    population: 10349312,
    timezone: "Asia/Seoul",
    geonameid: 1835848,
  },
  {
    name: "Paris",
    ascii_name: "Paris",
    latitude: 48.8566,
    longitude: 2.3522,
    country_code: "FR",
    admin1_code: "IDF",
    population: 2161000,
    timezone: "Europe/Paris",
    geonameid: 2988507,
  },
];

// Search function for the cities list
export function searchCities(query, citiesList = cities) {
  if (!query || query.length < 2) return [];

  const queryLower = query.toLowerCase();
  const results = [];

  for (const city of citiesList) {
    // Check if query matches city name (case insensitive)
    if (
      city.name.toLowerCase().includes(queryLower) ||
      city.ascii_name.toLowerCase().includes(queryLower)
    ) {
      results.push(city);
    }

    // Limit results to 10
    if (results.length >= 10) break;
  }

  return results;
}

// Get city by coordinates (for reverse lookup)
export function findCityByCoordinates(lat, lon, citiesList = cities) {
  let closestCity = null;
  let minDistance = Infinity;

  for (const city of citiesList) {
    const distance = Math.sqrt(
      Math.pow(city.latitude - lat, 2) + Math.pow(city.longitude - lon, 2)
    );

    if (distance < minDistance) {
      minDistance = distance;
      closestCity = city;
    }
  }

  // Only return if within reasonable distance (roughly 50km)
  return minDistance < 0.5 ? closestCity : null;
}

// Get cities by country code
export function getCitiesByCountry(countryCode, citiesList = cities) {
  return citiesList.filter(
    (city) => city.country_code === countryCode.toUpperCase()
  );
}

// Get top cities by population
export function getTopCities(limit = 10, citiesList = cities) {
  return [...citiesList]
    .sort((a, b) => b.population - a.population)
    .slice(0, limit);
}
